module.exports = __webpack_public_path__ + "img/menu_exit.74b36817.svg";